import React from 'react';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import EventAddonItemBlock from './components/EventAddonItemBlock';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../constants/event-items';
import { sortEventAddonItemsByPriority } from '../../util';

const propTypes = {
  setStepProps: PropTypes.func.isRequired,
  stepProps: PropTypes.shape({
    eventAddonItems: PropTypes.array,
    onEventAddonItemToggle: PropTypes.func,
    currentSelectedEventAddonItemIds: PropTypes.arrayOf(PropTypes.string),
  }),
};

const FreemiumEventCreateSKUSelectionStep = ({ stepProps, setStepProps }) => {
  const {
    eventType,
    eventAddonItems,
    currentSelectedEventAddonItemIds,
    onEventAddonItemToggle,
    allowFreeAlbums,
  } = stepProps;

  const availableEventAddonItems = sortEventAddonItemsByPriority(
    eventAddonItems.filter(eventAddonItem =>
      allowFreeAlbums
        ? eventAddonItem.types.length === 1 &&
          !eventAddonItem.types.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED)
        : eventAddonItem.types.length === 1,
    ),
  );

  const waldofiedItem = eventAddonItems.find(eventAddonItem =>
    eventAddonItem.types.includes(EVENT_ADDON_ITEM_TYPE.WALDOFIED),
  );

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        {allowFreeAlbums && (
          <EventAddonItemBlock
            onToggle={() => {
              if (
                stepProps.includePhotosAlbum &&
                currentSelectedEventAddonItemIds.includes(waldofiedItem.id)
              ) {
                onEventAddonItemToggle(waldofiedItem.id);
              }

              setStepProps({
                ...stepProps,
                includePhotosAlbum: !stepProps.includePhotosAlbum,
              });
            }}
            isSelected={stepProps.includePhotosAlbum}
            eventAddonItem={{
              id: 'includePhotosAlbum',
              types: ['PHOTO_ALBUMS'],
              price: waldofiedItem?.price,
            }}
          />
        )}
        <p className="freemium-event-sku-selection-more-albums">
          <span>More Premium Albums</span>
        </p>
        <div className="two-column-grid">
          {availableEventAddonItems.map(eventAddonItem => {
            return (
              <EventAddonItemBlock
                key={eventAddonItem.id}
                onToggle={() => {
                  onEventAddonItemToggle(eventAddonItem.id);
                  if (
                    !allowFreeAlbums &&
                    eventAddonItem.types[0] === EVENT_ADDON_ITEM_TYPE.WALDOFIED
                  ) {
                    setStepProps({
                      ...stepProps,
                      includePhotosAlbum: !stepProps.includePhotosAlbum,
                    });
                  }
                }}
                isSelected={currentSelectedEventAddonItemIds.includes(
                  eventAddonItem.id,
                )}
                eventAddonItem={eventAddonItem}
                eventType={eventType}
                itemStyle="squared"
              />
            );
          })}
        </div>
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateSKUSelectionStep.propTypes = propTypes;

export default FreemiumEventCreateSKUSelectionStep;
